import { createContext, useContext } from 'react'

import { ClientUserListResponse, ClientUsersListFilterParams } from '~bank-client-users/types'

type ClientUsersListContextValue = {
  data: ClientUserListResponse
  isPending: boolean
  successFullyLoaded: boolean
  state: ClientUsersListFilterParams
  navigate: (searchParams: Partial<ClientUsersListFilterParams>) => Promise<void>
  clear: () => void
}

export const ClientUsersListContext = createContext<ClientUsersListContextValue | null>(null)

export const useClientUsersListContext = () => {
  const context = useContext(ClientUsersListContext)

  if (!context) {
    throw new Error('useClientUsersListContext must be used within a ClientUsersListContext.Provider')
  }

  return context
}
